import axios from "axios";
import alert from "@/lang/AlertMessages.js";
import label from "@/lang/StaticLabels.js";
const saleUrl = "sale/api/v1/";

export default {
  // FeedBackType Actions ------------------------------------------------------------------
  getFeedBackTypes({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "basic/FeedBackType")
      .then((res) => {
        commit("setFeedBackTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addFeedBackType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "basic/FeedBackType", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editFeedBackType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "basic/FeedBackType/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteFeedBackType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "basic/FeedBackType", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getFeedBackTypeCode({ dispatch, commit }) {
    axios
      .get(saleUrl + "basic/FeedBackType/MaxCode")
      .then((res) => {
        commit("setFeedBackTypeCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // FeedBack Actions ------------------------------------------------------------------
  getFeedBack({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "basic/FeedBack")
      .then((res) => {
        commit("setFeedBack", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getFeedBackItem({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "basic/FeedBack/" + data)
      .then((res) => {
        commit("setFeedBackItem", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addFeedBack({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "basic/FeedBack", data)
      .then((res) => {
        commit("setFeedBackId", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editFeedBack({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "basic/FeedBack/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteFeedBack({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "basic/FeedBack", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getFeedBackCode({ dispatch, commit }) {
    axios
      .get(saleUrl + "basic/Feedback/MaxCode")
      .then((res) => {
        commit("setFeedBackCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // FeedbackQuestion Actions ------------------------------------------------------------------
  getFeedbackQuestion({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "basic/FeedbackQuestion?" + data)
      .then((res) => {
        commit("setFeedbackQuestion", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addFeedbackQuestion({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "basic/FeedbackQuestion", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editFeedbackQuestion({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "basic/FeedbackQuestion/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteFeedbackQuestion({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "basic/FeedbackQuestion", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  // FeedbackAnswers Actions ------------------------------------------------------------------
  getFeedbackAnswers({ dispatch, commit }, data) {
    axios
      .get(saleUrl + "basic/FeedbackQuestionAnswer?" + data)
      .then((res) => {
        commit("setFeedbackAnswers", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

   getFeedbackAnswer({ dispatch, commit }, data) {
    axios
      .get(saleUrl + "basic/FeedbackQuestionAnswer/" + data)
      .then((res) => {
        commit("setFeedbackAnswer", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addFeedbackAnswer({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "basic/FeedbackQuestionAnswer", data)
      .then((res) => {
        commit("setFeedbackAnswerId", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editFeedbackAnswer({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "basic/FeedbackQuestionAnswer/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteFeedbackAnswer({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "basic/FeedbackQuestionAnswer", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  // FeedbackQuestionOption Actions ------------------------------------------------------------------
  getFeedbackQuestionOptions({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "basic/FeedbackQuestionOption?")
      .then((res) => {
        commit("setFeedbackQuestionOptions", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFeedbackQuestionOption({ dispatch, commit }, data) {
    axios
      .get(saleUrl + "basic/FeedbackQuestionOption/" + data)
      .then((res) => {
        commit("setFeedbackQuestionOption", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addFeedbackQuestionOption({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "basic/FeedbackQuestionOption", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editFeedbackQuestionOption({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "basic/FeedbackQuestionOption/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteFeedbackQuestionOption({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "basic/FeedbackQuestionOption", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // PersonClubGroup Actions ------------------------------------------------------------------
  getPersonClubGroup({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "basic/PersonClubGroup")
      .then((res) => {
        commit("setPersonClubGroup", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addPersonClubGroup({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "basic/PersonClubGroup", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editPersonClubGroup({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "basic/PersonClubGroup/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deletePersonClubGroup({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "basic/PersonClubGroup", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPersonClubGroupCode({ dispatch, commit }) {
    axios
      .get(saleUrl + "basic/PersonClubGroup/MaxCode")
      .then((res) => {
        commit("setPersonClubGroupCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // SalesChannel Actions ------------------------------------------------------------------
  getSalesChannel({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "basic/SalesChannel")
      .then((res) => {
        commit("setSalesChannel", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addSaleChannel({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "basic/SalesChannel", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editSaleChannel({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "basic/SalesChannel/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteSalesChannel({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "basic/SalesChannel", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getSalesChannelCode({ dispatch, commit }) {
    axios
      .get(saleUrl + "basic/SalesChannel/MaxCode")
      .then((res) => {
        commit("setSalesChannelCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // IntroducedType Actions ------------------------------------------------------------------
  getIntroducedType({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "basic/IntroducedType")
      .then((res) => {
        commit("setIntroducedType", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addIntroducedType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "basic/IntroducedType", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editIntroducedType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "basic/IntroducedType/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteIntroducedType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "basic/IntroducedType", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getIntroducedTypeCode({ dispatch, commit }) {
    axios
      .get(saleUrl + "basic/IntroducedType/MaxCode")
      .then((res) => {
        commit("setIntroducedTypeCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // CustomerTag Actions ------------------------------------------------------------------
  getCustomerTag({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "basic/Tag")
      .then((res) => {
        commit("setCustomerTag", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addCustomerTag({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "basic/Tag", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCustomerTag({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "basic/Tag/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteCustomerTag({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "basic/Tag", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getCustomerTagCode({ dispatch, commit }) {
    axios
      .get(saleUrl + "basic/Tag/MaxCode")
      .then((res) => {
        commit("setCustomerTagCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // OccasionType Actions ------------------------------------------------------------------
  getOccasionType({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "basic/OccasionType")
      .then((res) => {
        commit("setOccasionType", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addOccasionType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "basic/OccasionType", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editOccasionType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "basic/OccasionType/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteOccasionType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "basic/OccasionType", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getOccasionTypeCode({ dispatch, commit }) {
    axios
      .get(saleUrl + "basic/OccasionType/MaxCode")
      .then((res) => {
        commit("setOccasionTypeCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // DeliveryMethod Actions ------------------------------------------------------------------
  getDeliveryMethods({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "basic/DeliveryMethod")
      .then((res) => {
        commit("setDeliveryMethods", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addDeliveryMethod({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "basic/DeliveryMethod", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editDeliveryMethod({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "basic/DeliveryMethod/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteDeliveryMethod({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "basic/DeliveryMethod", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getDeliveryMethodCode({ dispatch, commit }) {
    axios
      .get(saleUrl + "basic/DeliveryMethod/MaxCode")
      .then((res) => {
        commit("setDeliveryMethodCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // PaymentMethod Actions ------------------------------------------------------------------
  getPaymentMethods({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "basic/PaymentMethod")
      .then((res) => {
        commit("setPaymentMethods", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addPaymentMethod({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "basic/PaymentMethod", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editPaymentMethod({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "basic/PaymentMethod/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deletePaymentMethod({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "basic/PaymentMethod", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPaymentMethodCode({ dispatch, commit }) {
    axios
      .get(saleUrl + "basic/PaymentMethod/MaxCode")
      .then((res) => {
        commit("setPaymentMethodCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Discount Actions ------------------------------------------------------------------
  getDiscounts({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "basic/Discount?" + data)
      .then((res) => {
        commit("setDiscounts", res.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getValidateDiscountCode({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "basic/Discount/search?" + data)
      .then((res) => {
        commit("setValidateDiscountCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getDiscount({ dispatch, commit }, data) {
    axios
      .get(saleUrl + "basic/Discount/" + data)
      .then((res) => {
        commit("setDiscount", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addDiscount({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "basic/Discount", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: "PCRMDiscountList",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editDiscount({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "basic/Discount/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: "PCRMDiscountList",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteDiscount({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "basic/Discount", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getDiscountCode({ dispatch, commit }) {
    axios
      .get(saleUrl + "basic/Discount/GenerateCode")
      .then((res) => {
        commit("setDiscountCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // PersonClub Actions ------------------------------------------------------------------
  getPersonsClub({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "operation/PersonClub?" + data)
      .then((res) => {
        commit("setPersonsClub", res.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPersonClubByMobile({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "operation/PersonClub/GetBy?mobile=" + data)
      .then((res) => {
        commit("setPersonClubByMobile", res.data.data);
      })
      .catch((error) => {
        commit("setPersonClubByMobile", {});
        if (error.response && error.response.status == 400) {
          commit("setError", alert.error.noCustomerClub, { root: true });
          setTimeout(() => {
            commit("setPersonClubModal", true);
          }, 1000);
        } else {
          dispatch("errorGETHandler", error, { root: true });
        }
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPersonClub({ dispatch, commit }, data) {
    axios
      .get(saleUrl + "operation/PersonClub/GetBy?" + data)
      .then((res) => {
        commit("setPersonClub", res.data.data);
        commit("setPersonSearchSuccess", true);
      })
      .catch((error) => {
        if (error.response && error.response.status === 400) {
          commit("setPersonSearchSuccess", false);
        }
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addPersonClub({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "operation/PersonClub", data)
      .then((res) => {
        commit("setPersonClub", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editPersonClub({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "operation/PersonClub/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: "PCRMPersonClubList",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deletePersonClub({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "operation/PersonClub", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPersonClubCode({ dispatch, commit }) {
    axios
      .get(saleUrl + "operation/PersonClub/MaxCode")
      .then((res) => {
        commit("setPersonClubCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPersonClubPurchase({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "operation/PersonClub/PersonClubPurchase?" + data)
      .then((res) => {
        commit("setPersonClubPurchase", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPersonClubSearch({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "operation/PersonClub/Search?mobile=" + data)
      .then((res) => {
        commit("setPersonClubSearch", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  // SmsSetting Actions ------------------------------------------------------------------
  getSmsSetting({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "basic/SmsSetting")
      .then((res) => {
        commit("setSmsSetting", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getSmsSettingById({ dispatch, commit }, data) {
    axios
      .get(saleUrl + "basic/SmsSetting/" + data)
      .then((res) => {
        commit("setSmsSettingById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addSmsSetting({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "basic/SmsSetting", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: "PCRMCongratulationsMsgSettings",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editSmsSetting({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "basic/SmsSetting/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: "PCRMCongratulationsMsgSettings",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteSmsSetting({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "basic/SmsSetting", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Process Actions ------------------------------------------------------------------
  getProcesses({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "basic/Process")
      .then((res) => {
        commit("setProcesses", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getProcess({ dispatch, commit }, data) {
    axios
      .get(saleUrl + "basic/Process/" + data)
      .then((res) => {
        commit("setProcess", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addProcess({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "basic/Process", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: "PCRMProcessList",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editProcess({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "basic/Process/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: "PCRMProcessList",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteProcess({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "basic/Process", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getProcessCode({ dispatch, commit }) {
    axios
      .get(saleUrl + "basic/Process/MaxCode")
      .then((res) => {
        commit("setProcessCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Purchase Actions ------------------------------------------------------------------
  getPurchases({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "basic/Purchase?" + data)
      .then((res) => {
        commit("setPurchases", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPurchase({ dispatch, commit }, data) {
    axios
      .get(saleUrl + "basic/Purchase/" + data)
      .then((res) => {
        commit("setPurchase", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addPurchase({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "basic/Purchase", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: "PCRMPOrderList",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editPurchase({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "basic/Purchase/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: "PCRMPersonClubList",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deletePurchase({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "basic/Purchase", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPurchaseCode({ dispatch, commit }) {
    axios
      .get(saleUrl + "basic/Purchase/MaxCode")
      .then((res) => {
        commit("setPurchaseCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

   getPurchaseSearchByMobile({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    return axios
      .get(saleUrl + "basic/Purchase/Search?mobile=" + data)
      .then((res) => {
        commit("setPurchaseSearchByMobile", res.data.data);
        return res.data.data;
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  // PersonClubGrade Actions ------------------------------------------------------------------
  getPersonClubGrades({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "basic/Grade")
      .then((res) => {
        commit("setPersonClubGrades", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPersonClubGrade({ dispatch, commit }, data) {
    axios
      .get(saleUrl + "basic/Grade/" + data)
      .then((res) => {
        commit("setPersonClubGrade", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addPersonClubGrade({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "basic/Grade", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editPersonClubGrade({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "basic/Grade/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deletePersonClubGrade({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "basic/Grade", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPersonClubGradeCode({ dispatch, commit }) {
    axios
      .get(saleUrl + "basic/Grade/MaxCode")
      .then((res) => {
        commit("setPersonClubGradeCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // ScoreTransaction Actions ------------------------------------------------------------------
  getScoreTransaction({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "basic/ScoreTransaction?" + data)
      .then((res) => {
        commit("setScoreTransaction", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addScoreTransaction({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "basic/ScoreTransaction", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  // CreditTransaction Actions ------------------------------------------------------------------
  getCreditTransaction({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "basic/CreditTransaction?" + data)
      .then((res) => {
        commit("setCreditTransaction", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  creditCancellation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "basic/CreditTransaction/Cancel", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addCreditTransaction({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "basic/CreditTransaction", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getValidateCreditCode({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "basic/CreditTransaction/Search?" + data)
      .then((res) => {
        commit("setValidateCreditCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getCustomerPurchaseReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(saleUrl + "Report/CustomerPurchase?" + data)
      .then((res) => {
        commit("setCustomerPurchaseReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getScoreSummeryReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "Report/ScoreSummery?" + data)
      .then((res) => {
        commit("setScoreSummery", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getFeedbackReport({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "Report/Feedback")
      .then((res) => {
        commit("setFeedbackReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getFeedbackDetailReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "Report/FeedbackDetail?" + data)
      .then((res) => {
        commit("setFeedbackDetailReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getAnswerPersonClub({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "Report/AnswerPersonClub?" + data)
      .then((res) => {
        commit("setAnswerPersonClub", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPersonClubFeedbackReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "Report/PersonClubFeedback?" + data)
      .then((res) => {
        commit("setPersonClubFeedbackReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPersonClubFeedbackLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "Report/PersonClubFeedbackLog?" + data)
      .then((res) => {
        commit("setPersonClubFeedbackLog", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getMostCustomerRegistrations({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "operation/Dashboard")
      .then((res) => {
        commit(
          "setMostCustomerRegistrations",
          res.data.data.mostCustomerRegistrations,
        );
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getRequirementProfile({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "basic/RequirementProfile")
      .then((res) => {
        commit("setRequirementProfile", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  editRequirementProfile({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "basic/RequirementProfile/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  // ApiKeyAccess Actions ------------------------------------------------------------------
  getApiKeyAccess({ dispatch, commit }) {
    axios
      .get(saleUrl + "basic/ApiKeyAccess")
      .then((res) => {
        commit("setApiKeyAccess", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  generateApiKeyAccess({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "basic/ApiKeyAccess", data)
      .then((res) => {
        commit("setApiKeyAccess", res.data.data);

        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  editApiKeyAccess({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "basic/ApiKeyAccess/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
};
